export default __webpack_public_path__ + "static/media/bazaar-logo-and-logotype 1.7aa98977.svg";